import { render, staticRenderFns } from "./StationDataWithFallbackStrategyForm.vue?vue&type=template&id=a38478d2&scoped=true"
import script from "./StationDataWithFallbackStrategyForm.vue?vue&type=script&lang=js"
export * from "./StationDataWithFallbackStrategyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38478d2",
  null
  
)

export default component.exports